// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__JSa1x","log":"ModalInventoryLogs_log__24yjt","date":"ModalInventoryLogs_date__3zd1m","userName":"ModalInventoryLogs_userName__2fv6r"};